import { lazy } from 'react';

// Analytics pages with Vercel-safe code splitting
// Using Vite's chunk naming instead of webpack comments to avoid Vercel issues

// Main analytics pages
export const AnalyticsOverview = lazy(() => import('@/pages/analytics/InsightsPage'));
export const GoogleAdsCampaignDetail = lazy(
  () => import('@/pages/analytics/GoogleAdsCampaignDetailPage'),
);
export const MetaAdsCampaignDetail = lazy(
  () => import('@/pages/analytics/MetaAdsCampaignDetailPage'),
);
export const LinkedInAdsCampaignDetail = lazy(
  () => import('@/pages/analytics/LinkedInAdsCampaignDetailPage'),
);
